/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_See_DemoInputs */

const en_marketing_see_demo = /** @type {(inputs: Marketing_See_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Demo`)
};

const es_marketing_see_demo = /** @type {(inputs: Marketing_See_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver demo`)
};

const fr_marketing_see_demo = /** @type {(inputs: Marketing_See_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la démo`)
};

/**
* | output |
* | --- |
* | "See Demo" |
*
* @param {Marketing_See_DemoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_see_demo = /** @type {((inputs?: Marketing_See_DemoInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_See_DemoInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_see_demo(inputs)
	if (locale === "es") return es_marketing_see_demo(inputs)
	return fr_marketing_see_demo(inputs)
});